module.exports = __webpack_public_path__ + "media/images/energize_action_icon-0e9133070f0f3589d9c933416ad62db7.png";